import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';
import { WarehouseService } from '../../../../warehouse/warehouse.service';

@Component({
  standalone: false,
  selector: 'app-material-autocomplete',
  templateUrl: './material-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss'],
})
export class MaterialAutocompleteComponent {
  @Input() placeholder: string;
  @Input() searchTerm: string;
  @Input() isProduct: boolean;
  @Input() isCatalog: boolean;
  @Input() isDisabled: boolean;
  @Input() workRequestId: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private sharedService: SharedService,
    private warehouseService: WarehouseService,
    private message: MessageService,
  ) {}

  getAllItems(): any {
    if (this.isCatalog) {
      this.getCatalogMaterials();
    } else {
      this.getAllMaterials();
    }
  }

  getAllMaterials(): void {
    const inputValue = this.isProduct ? this.searchTerm : this.input;
    this.sharedService.getAllMaterials(inputValue, this.workRequestId).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && inputValue.length > 0;
      },
      err => {
        this.message.error(err);
      },
    );
  }

  getCatalogMaterials(): void {
    const inputValue = this.isProduct ? this.searchTerm : this.input;
    if (!inputValue || inputValue.length < 1) {
      this.items = [];
      this.isListVisible = false;
      return;
    }
    this.warehouseService.getMaterialCatalogItems({ search: inputValue }).subscribe(
      res => {
        this.items = res.results || [];
        this.isListVisible = this.items.length > 0;
      },
      err => {
        this.message.error(err);
      },
    );
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;

    if (!this.isProduct) {
      this.input = item.name;
    } else {
      this.searchTerm = item.name;
    }
  }

  trackByFn(index: number): number {
    return index;
  }
}
